module.exports = __webpack_public_path__ + "img/bb.15d8bd09.png";